import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import { initializeState, reportCleared } from "../../../store/sdlcReportSlice";
import { initFilter, initPagination, initSort } from "../secrets/utils";
import { resetAllSlices, restoreState } from "./utils";
export const initialState = {
    filter: initFilter,
    sort: initSort,
    pagination: initPagination,
    filteredByLink: false,
};
const secretsSlice = createSlice({
    name: "fileBrowserSecrets",
    initialState: initialState,
    reducers: {
        filterUpdated: (state, action) => {
            state.filter = cloneDeep(action.payload);
            state.filteredByLink = false;
            state.pagination.currentPage = 1;
        },
        filterByLiveness: (state, action) => {
            state.filter = cloneDeep(initFilter);
            state.filter.secret_liveness = action.payload;
            state.filter.hide_triaged = false;
            state.filteredByLink = true;
            state.pagination.currentPage = 1;
        },
        filterByService: (state, action) => {
            state.filter = cloneDeep(initFilter);
            state.filter.service = action.payload;
            state.filter.hide_triaged = false;
            state.filteredByLink = true;
            state.pagination.currentPage = 1;
        },
        hideTriagedUpdated: (state, action) => {
            state.filter = cloneDeep(initFilter);
            state.filter.hide_triaged = action.payload;
            state.filteredByLink = true;
            state.pagination.currentPage = 1;
        },
        sortUpdated: (state, action) => {
            state.sort = action.payload;
            state.pagination.currentPage = 1;
        },
        paginationUpdated: (state, action) => {
            state.pagination = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(initializeState, (state, action) => {
            return restoreState(state, action.payload, "secrets");
        });
        builder.addCase(reportCleared, () => {
            return cloneDeep(initialState);
        });
        builder.addCase(resetAllSlices, () => {
            return cloneDeep(initialState);
        });
    },
});
export const secretsReducer = secretsSlice.reducer;
export const { filterByLiveness, filterByService, hideTriagedUpdated, sortUpdated, paginationUpdated, filterUpdated, } = secretsSlice.actions;
export const selectFilter = (state) => state.report.fileBrowser.secrets.filter;
export const selectSort = (state) => state.report.fileBrowser.secrets.sort;
export const selectPagination = (state) => state.report.fileBrowser.secrets.pagination;
export const selectFilteredByLink = (state) => state.report.fileBrowser.secrets.filteredByLink;
//# sourceMappingURL=secretsSlice.js.map